/**
 * True when the route is an authenticated admin/dashboard area (not marketing or auth).
 * Pair with a signed-in user check before showing ion-menu.
 */

const AUTH_EXACT = new Set([
  "/login",
  "/confirm",
  "/new-password",
  "/reset-password",
  "/enquiries/login",
  "/enquiries/new-password",
  "/enquiries/reset-password",
  "/enquiries/email-responses",
  "/enquiries/stats",
  "/enquiries/submission-logs",
]);

/** Dashboard / admin app sections (prefix match). */
const DASHBOARD_PREFIXES = [
  "/dashboard",
  "/get-started",
  "/onboarding",
  "/proposal",
  "/tech-setup",
  "/project",
  "/project-brief",
  "/project-briefs",
  "/projects",
  "/proposals",
  "/project-setup",
  "/project-spec",
  "/app-admin",
  "/app-design",
  "/packages",
  "/manage-clients",
  "/stats",
  "/email-responses",
  "/client-resources",
  "/dev-resources",
  "/features",
  "/enquiry",
  "/submission-logs",
] as const;

/** Normalise a URL path for route matching (exported for composables). */
export function normalizeAppPath(path: string): string {
  if (!path || path === "/") return "/";
  return path.replace(/\/+$/, "") || "/";
}

/** Public marketing routes that should SSR and skip portal CSS/fonts. */
export function isMarketingPath(path: string): boolean {
  const p = normalizeAppPath(path);
  if (p === "/") return true;
  if (p === "/contact") return true;
  if (p.startsWith("/case-studies")) return true;
  if (p === "/app-suite" || p.startsWith("/app-suite/")) return true;
  if (p === "/testimonials" || p.startsWith("/testimonials/")) return true;
  return false;
}

function isDashboardPrefixPath(path: string): boolean {
  if (path === "/enquiries") return true;
  if (path.startsWith("/enquiries/projects")) return true;
  if (path.startsWith("/enquiries/")) return false;

  return DASHBOARD_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isDashboardPage(path: string): boolean {
  const p = normalizeAppPath(path);
  if (isMarketingPath(p)) return false;
  if (AUTH_EXACT.has(p)) return false;
  return isDashboardPrefixPath(p);
}
